import { useContext } from 'react';

import { ClientsContext, type IClientsContextData } from '../contexts/company';

export const useClients = (): IClientsContextData => useContext(ClientsContext);
